import { clsx } from 'clsx'
import { useDropzone } from 'react-dropzone'

import type { ReactNode } from 'react'

interface FileDropzoneProperties {
  accept: Record<string, string[]>
  activeClassName?: string
  children: ReactNode | ((state: { isDragActive: boolean }) => ReactNode)
  className?: string
  disabledClassName?: string
  isDisabled?: boolean
  maxFiles?: number
  onFilesDropped: (files: File[]) => void
  testId?: string
}

export const FileDropzone = ({
  accept,
  activeClassName,
  children,
  className,
  disabledClassName,
  isDisabled = false,
  maxFiles = 1,
  onFilesDropped,
  testId,
}: FileDropzoneProperties) => {
  /* --- Section 1: Hooks --- */
  const { getInputProps, getRootProps, isDragActive } = useDropzone({
    accept,
    disabled: isDisabled,
    maxFiles,
    onDrop: onFilesDropped,
  })

  /* --- Section 6: Render --- */
  return (
    <div
      {...getRootProps()}
      className={clsx(className, isDragActive && activeClassName, isDisabled && disabledClassName)}
      data-testid={testId}
    >
      <input {...getInputProps()} />
      {typeof children === 'function' ? children({ isDragActive }) : children}
    </div>
  )
}
